// Staff login. Password is the primary door (0003 — email delivery is not
// wired yet); #/auth?token=… still redeems manually issued magic links.
import { useEffect, useState } from 'preact/hooks';
import { api, setToken } from '../api';

export function LoginPage({ authToken }: { authToken?: string }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [state, setState] = useState<'idle' | 'busy' | 'error'>(authToken ? 'busy' : 'idle');

  useEffect(() => {
    if (!authToken) return;
    api
      .verify(authToken)
      .then((r) => {
        setToken(r.token);
        location.hash = '#/';
        // App fetched `me` once on mount — before this token existed — and
        // cached null. Without a reload the user lands back on the login form
        // with a valid session in localStorage. Mirrors the logout path.
        location.reload();
      })
      .catch(() => setState('error'));
  }, [authToken]);

  const submit = async (e: Event) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setState('busy');
    try {
      const r = await api.login(email.trim(), password);
      setToken(r.token);
      location.hash = '#/';
      location.reload();
    } catch {
      setState('error');
    }
  };

  if (authToken && state === 'busy') return <div class="login"><p>Входим…</p></div>;

  return (
    <div class="login">
      <h1>Datoric — дашборд</h1>
      <p>Вход для сотрудников. Логин и пароль выдаёт менеджер.</p>
      <form onSubmit={submit}>
        <input
          type="email"
          placeholder="почта"
          value={email}
          autocomplete="username"
          onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
        />
        <input
          type="password"
          placeholder="пароль"
          value={password}
          autocomplete="current-password"
          onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
        />
        <button class="primary" disabled={state === 'busy' || !email.trim() || !password}>
          {state === 'busy' ? 'Входим…' : 'Войти'}
        </button>
      </form>
      {state === 'error' && (
        <div class="msg err">Войти не получилось: почта или пароль не подходят. Новые данные для входа выдаёт менеджер.</div>
      )}
    </div>
  );
}
